import React from 'react';

var _path;

var SvgTeamMajor = function SvgTeamMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.086 9.882a5 5 0 1 1 3.91-5.063l4.378.73A3 3 0 0 1 20 7a3 3 0 0 1-3.919 2.857l-2.866 3.763a4 4 0 1 1-5.77-.697l-1.36-3.041zm1.826-.817 1.342 3.005a4.022 4.022 0 0 1 2.407.29l2.83-3.716a2.983 2.983 0 0 1-.446-1.123L9.67 6.792a5.015 5.015 0 0 1-1.757 2.273z"
  })));
};

export { SvgTeamMajor as S };
